import { render, staticRenderFns } from "./CampaignCouponDiscountForm.vue?vue&type=template&id=1ba7c09b"
import script from "./CampaignCouponDiscountForm.vue?vue&type=script&lang=js"
export * from "./CampaignCouponDiscountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports